
<h4 class="mb-3 text-center mt-2">{{ 'Login.Welcom' | translate }} 
  <!-- <language class="language-fix"></language> -->
</h4>
<p class="mb-4 text-center ">{{ 'Login.Description' | translate }}</p>


<form (ngSubmit)="onSubmit()" #loginForm="ngForm" autocomplete="off" novalidate class="mb-3">
  <div class="mb-3 validation-alert">
    <label for="username" class="form-label">{{'username' | translate}}</label>

    <input type="text" id="username" name="username" class="form-control text-start" [(ngModel)]="login.username"
      #email="ngModel" required minlength="5" maxlength="400"  dir="ltr"
      placeholder="{{'username'| translate }}" autofocus>

    <div class="alert alert-danger " *ngIf="email.invalid && email.dirty">
      <span class="help-block" *ngIf="email.errors?.['required']">
        {{ 'Required' | translate }}
      </span>
      <span class="help-block" *ngIf="email.errors?.['minlength']">
        {{ 'MinLenght' | translate : {'value':'5'} }}
      </span>
      <span class="help-block" *ngIf="email.errors?.['maxlength']">
        {{ 'MaxLenght' | translate : {'value':'20'} }}
      </span>
    </div>
  </div>
  <div class="mb-3 form-password-toggle validation-alert">
    <div class="d-flex justify-content-between">
      <label class="form-label" for="password">{{ 'password' | translate }}</label>
      <a routerLink="/forgotPassword">
        <small>{{ 'ForgotPassword' | translate}}</small>
      </a>
    </div>
    <div class="input-group input-group-merge">
      <input [attr.type]="passwordIsShow" id="password" name="password" [(ngModel)]="login.password" #password="ngModel"
        required minlength="8" maxlength="400" class="form-control text-start" dir="ltr"
        placeholder="{{ 'Password' | translate }}" aria-describedby="password">
      <span class="input-group-text cursor-pointer" (click)="changePasswordState()">
        <i class="bx bx-hide"
          [ngClass]="{'bx-hide':passwordIsShow=='password','bx-show':passwordIsShow!='password'}"></i>
      </span>
    </div>
    <div class="alert alert-danger" *ngIf="password.invalid && password.dirty">
      <span class="help-block" *ngIf="password?.errors?.['required']">
        {{ 'Required' | translate }}
      </span>
      <span class="help-block" *ngIf="password?.errors?.['minlength']">
        {{ 'MinLenght' | translate : {'value':'8'} }}
      </span>
      <span class="help-block" *ngIf="password?.errors?.['maxlength']">
        {{ 'MaxLenght' | translate : {'value':'40'} }}
      </span>
    </div>
  </div>
  <div class="mb-3">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="remember-me">
      <label class="form-check-label" for="remember-me">{{ 'RememberMe' | translate }}</label>
    </div>
  </div>
  <div class="mb-3">
    <button class="btn btn-primary d-grid w-100" type="submit" [disabled]="!loginForm.form.valid">{{ 'login' | translate}}</button>
  </div>
  <app-loading-panel *ngIf="submitted"></app-loading-panel>
</form>

<p class="text-center margin-xy">
  <a routerLink="/register">
    <span>{{ 'Register' | translate }}</span>
  </a>
</p>

<div class="divider margin-xy">
  <div class="divider-text">{{ 'Or' | translate }}</div>
</div>


<div class="d-flex justify-content-center">
  <a href="javascript:;" class="btn btn-icon btn-label-facebook me-3">
    <i class="tf-icons bx bxl-facebook"></i>
  </a>

  <a href="javascript:;" class="btn btn-icon btn-label-google-plus me-3">
    <i class="tf-icons bx bxl-google-plus"></i>
  </a>

  <a href="javascript:;" class="btn btn-icon btn-label-twitter">
    <i class="tf-icons bx bxl-twitter"></i>
  </a>
</div>




